import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TranslatePipe } from '../../services/i18n/i18n.module';
import { AppFooterMenuComponent } from './menu/footer-menu';

@Component({
  selector: 'shared-footer',
  imports: [TranslatePipe, AppFooterMenuComponent],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {}
